import useYardActionEvents from "@hsl/core/hooks/useYardAnalyticsEvents";
import cx from "@hsl/core/utils/cx";
import useFCSubscriptionStore from "@hsl/fc-subscription/store";

import { Translate } from "../../../../../hooks/useTranslation";
import { useSelectDocumentContext } from "./context";
import SelectDocumentsCollapsible from "./SelectDocumentsCollapsible";

const CollapsibleContainer = () => {
    const { checkboxEvent } = useYardActionEvents();
    const basket = useFCSubscriptionStore(
        (state) => state.flowSteps["select-funds"].data,
    );
    const context = useSelectDocumentContext();
    const {
        createSubscriptions,
        allDocuments,
        keyDocuments,
        status,
        stepData,
        updateSelection,
    } = context;
    const { funds, shareClasses } = basket ?? {};
    const hasData =
        Array.isArray(funds) &&
        Array.isArray(shareClasses) &&
        funds.length > 0 &&
        shareClasses.length > 0;
    const handleApplyToAll = () => {
        context.applyToAllFunds = !context.applyToAllFunds;
        checkboxEvent({
            name: "Apply document selection to all selected funds",
            details: context.applyToAllFunds ? "Yes" : "No",
        });
    };
    return (
        <>
            <label className="flex items-center gap-2 max-sm:text-sm">
                <input
                    type="checkbox"
                    checked={context.applyToAllFunds}
                    onChange={handleApplyToAll}
                />{" "}
                <Translate>
                    Apply document selection to all selected funds
                </Translate>
            </label>
            {hasData &&
                (context.applyToAllFunds ? (
                    <SelectDocumentsCollapsible
                        funds={funds}
                        shareClasses={shareClasses}
                        docSubscriptionCreator={createSubscriptions}
                        allDocuments={allDocuments}
                        keyDocuments={keyDocuments}
                        status={status}
                        subscriptions={stepData.data?.subscriptions}
                        onUpdate={updateSelection}
                    />
                ) : (
                    funds.map((fund, i) => (
                        <div key={`doc-select-${fund.data.id}`}>
                            <h4
                                className={cx(
                                    "text-l-g-blue mb-2 text-lg font-medium",
                                    i > 0 ? "mt-10" : "mt-4",
                                )}
                            >
                                {fund.data.data.name}
                            </h4>
                            <SelectDocumentsCollapsible
                                funds={[fund]}
                                shareClasses={shareClasses.filter((sc) =>
                                    fund.data.share_classes.includes(
                                        sc.data.id,
                                    ),
                                )}
                                docSubscriptionCreator={createSubscriptions}
                                allDocuments={allDocuments}
                                keyDocuments={keyDocuments}
                                status={status}
                                subscriptions={stepData.data?.subscriptions}
                                onUpdate={updateSelection}
                            />
                        </div>
                    ))
                ))}
        </>
    );
};

export default CollapsibleContainer;
